import { render, staticRenderFns } from "./ShoppeProduct.vue?vue&type=template&id=10e6d5de&"
import script from "./ShoppeProduct.vue?vue&type=script&lang=js&"
export * from "./ShoppeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\happyboxstore-repo\\shoppe\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e6d5de')) {
      api.createRecord('10e6d5de', component.options)
    } else {
      api.reload('10e6d5de', component.options)
    }
    module.hot.accept("./ShoppeProduct.vue?vue&type=template&id=10e6d5de&", function () {
      api.rerender('10e6d5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Shoppe/components/ShoppeProduct.vue"
export default component.exports